import React from "react";
import HrReferralList from "../../component/Referral/HrReferralList.tsx";

const ReferalTablePage = () => {
  return (
    <div>
      <HrReferralList />
    </div>
  );
};

export default ReferalTablePage;
